import * as React from 'react';
import { Box, TablePagination, TextField, Button, Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface pageNumberProps {
  displayPage?: true | false;
  handleGotoSubmit?: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonMargin: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1)
    }
  })
);

const PageNumber = (props: pageNumberProps) => {
  const classes = useStyles();
  const [pageNumber, setPageNumber] = React.useState('');

  const handlePageNumber = (e: any) => {
    const data = e.target.value;
    setPageNumber(data);
  };

  const handleGotoSubmit = () => {
    props.handleGotoSubmit(pageNumber);
  };
  return (
    <>
      <Box>
        <Grid container>
          <Grid item xs={6}>
            <TextField
              data-id="specific-page"
              id="specific-page"
              label="Page Number"
              disabled={false}
              value={pageNumber || ''}
              onChange={e => handlePageNumber(e)}
            ></TextField>
          </Grid>
          <Grid item xs={6}>
            <Button
              data-id="Enter-Button"
              className={classes.buttonMargin}
              variant="outlined"
              color="primary"
              disableElevation
              onClick={handleGotoSubmit}
            >
              Go To Page
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default PageNumber;
